import React from "react";
import styles from "./navbar.module.scss";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import { PATH } from "../../router/path";

export const Navbar = () => {
  const location = useLocation();
  return (
    <ul className={styles.navbar}>
      <Link to={PATH.CATALOGUES} className={classNames(styles.li, {[styles.active]: location.pathname.includes(PATH.CATALOGUES)}) }>Справочники</Link>
      <Link to={PATH.REPORTS} className={classNames(styles.li, {[styles.active]: location.pathname.includes(PATH.REPORTS)}) }>Отчеты</Link>
    </ul>
  );
};
